/** ----------------------------------------
    Search Overlay
 ---------------------------------------- */

/**
 * The search overlay class will handle search overlay interactions
 */

export class SearchOverlay {

    /** ----------------------------------------
        Constructor
     ---------------------------------------- */

    constructor() {
        this.overlay = document.querySelector('.js-search-overlay');
        this.toggleNavSearch = document.querySelector('.js-search-toggle');
        this.navSearch = document.querySelector('.js-nav-search-overlay');
        this.navSearchinput = document.querySelector('.js-search-input');

        this.isOpen = false;

        this.init();
    }

    open() {
        this.isOpen = true;
        this.overlay.classList.add('active');
        document.body.classList.add('search-active');
        this.navSearchinput.focus();
        this.navSearchinput.setSelectionRange(0, this.navSearchinput.value.length);
    }

    close() {
        this.isOpen = false;
        this.overlay.classList.remove('active');
        document.body.classList.remove('search-active');
    }

    addToggleEvent() {
        this.toggleNavSearch.addEventListener('click', (e) => {
            e.preventDefault();
            (this.isOpen) ? this.close() : this.open();
        });
    }

    addOverlayEvent() {
        this.overlay.addEventListener('click', (e) => {
            e.preventDefault();
            this.close()
        });
    }

    /**
     * Initialize
     * @returns {void}
     */
    init() {
        this.addToggleEvent();
        this.addOverlayEvent();
    }
}